import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { AddRFQTemplate as template } from './add-rfq.template';
import { AddRFQStyles as styles } from './add-rfq.styles';
import { RfqForm } from '../../rfq-modal/rfq-form/rfq-form';
import { IEnumService } from '../../../../services/enum.service';
import { IStructuredChatService } from '../../../../services/structured-chat.service';
import { IRfqService, IVppaService } from '../../../../services';
import { IVppa } from '../../../../types';
import { logger } from '@genesislcap/foundation-comms';
import { notify, notifyError } from '../../../../utils/notify';

const name = 'add-rfq';

@customElement({
  name,
  template,
  styles,
})
export class AddRFQ extends FASTElement {
  @IStructuredChatService structuredChatService: IStructuredChatService;
  @IVppaService vppaService: IVppaService;
  @IEnumService enumService: IEnumService
  @IRfqService rfqService: IRfqService;
  @observable isFormValid: boolean = false;
  @observable vppa: IVppa = {} as IVppa;
  @observable rfqForm: RfqForm;

  connectedCallback() {
    super.connectedCallback();
    this.rfqForm?.loadData(null, false);

    this.getVPPAData();
  }

  public getVPPAData() {
    if (this.structuredChatService.selectedVPPAIDs.length > 0) {
      this.vppaService.getVppa(this.structuredChatService.selectedVPPAIDs[0]).then((response) => {
        if (response) {
          this.vppa = response.REPLY[0];
        }
      });
    }
  }

  public submitForm() {
    const formData = this.rfqForm.getFormData();
    this.rfqService.eventRfqInsert(formData).then(
      (response) => {
        if (response && response.MESSAGE_TYPE === 'EVENT_ACK') {
          this.structuredChatService.selectedRFQIDs.push(response.GENERATED[0].RFQ_ID);
          this.rfqForm.clearForm();
          this.$emit('closeAddRfq', true);
        } else {
          notifyError(response.ERROR[0].TEXT);
          logger.error(response);
        }
      },
      (error) => {
        notifyError(error);
        logger.error(error);
      }
    );
  }

  public cancel() {
    this.rfqForm.clearForm();
    this.$emit('closeAddRfq', true);
  }
}
